import * as React from 'react';
import { ISODateTime } from '../../../../../admin/types/date';
import moment from 'moment-timezone';
import './reservableSlotCard.module.scss';
import { Token } from '../../../../types/tokens';
import { ReservationIndexView } from '../../../../types/reservations';
import { SimpleDate } from '../../../../../admin/components/date/TimeRange';

type LabelProps = { r: ReservationIndexView };

const ReservationLabel = ({ r }: LabelProps) => (
    <div styleName="reservation-label">
        <SimpleDate date={r.reservable.starts_at} />&nbsp;{moment(r.reservable.starts_at).format('HH:mm')}~
    </div>
);

type AvailabilityLabelProps = { t: Token };
const AvailabilityLabel = ({ t }: AvailabilityLabelProps) => (
    <div styleName="availability-label">
        <SimpleDate date={t.effective_at} />~<SimpleDate date={t.expires_at} />の間で1回予約できます。
    </div>
);

type ReservableCardProps = {
    title: string;
    currentToken?: Token;
    nextToken?: Token;
    reservationList: ReservationIndexView[];
    actionButton: any;
};
export const ReservableSlotCard = ({
    title,
    currentToken,
    nextToken,
    reservationList,
    actionButton,
}: ReservableCardProps) => {
    return (
        <div styleName="card">
            <div styleName="left">
                <div styleName="title">{title}</div>
                <div styleName="remaining">
                    {reservationList.length > 0 && (
                        <div styleName="reservations">
                            {reservationList.map((r) => <ReservationLabel key={r.id} r={r} />)}
                        </div>
                    )}
                    {currentToken && currentToken.amount > 0 && <AvailabilityLabel t={currentToken} />}
                    {(!currentToken || currentToken.amount <= 0) &&
                        nextToken &&
                        nextToken.amount > 0 && <AvailabilityLabel t={nextToken} />}
                </div>
            </div>
            {actionButton}
        </div>
    );
};
